import { makeStyles } from "../Utilities/ThemeHelper";
const useStyles = makeStyles(theme => ({
  menu: {
    list: {
      padding: theme.spacing(1, 0)
    }
  },
  button: {},
  item: {
    padding: theme.spacing(1, 2),
    "&:active": {
      backgroundColor: theme.palette.action.selected
    }
  },
  paper: {
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[5],
    ...theme.scrollbars?.main,
    overflowX: "hidden"
  }
}));
export default useStyles;